export const commonMonitoringStyles = {
  monitoringChartContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    minWidth: 400,
    pl: 2,
  },
};
